import { render, staticRenderFns } from "./textImgHasMenu.vue?vue&type=template&id=b73042ca&scoped=true&"
import script from "./textImgHasMenu.vue?vue&type=script&lang=js&"
export * from "./textImgHasMenu.vue?vue&type=script&lang=js&"
import style0 from "./textImgHasMenu.vue?vue&type=style&index=0&id=b73042ca&prod&lang=scss&"
import style1 from "./textImgHasMenu.vue?vue&type=style&index=1&id=b73042ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73042ca",
  null
  
)

export default component.exports